import { Box, ModalHeader, Typo } from '@wrisk/ui-components'
import React, { FunctionComponent, ReactNode } from 'react'

export interface RetrievePageErrorProps {
  title: ReactNode
  message: ReactNode
}

export const RetrievePageError: FunctionComponent<RetrievePageErrorProps> = ({
  title,
  message,
}) => (
  <Box>
    <ModalHeader header={title} />
    <Typo>{message}</Typo>
  </Box>
)
